import { useCallback, useMemo, useState } from 'react';
import { useToast } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { exportMembers, validateApiResponse } from '../../../services';
import { downloadTextFile } from '../utils/downloadTextFile';

/** Export CSV of the Members header: the full member list (provisional scope), with toasts. */
export const useMembersExport = () => {
  const { t } = useTranslation('people-access');
  const toast = useToast();
  const [isExporting, setIsExporting] = useState(false);

  const exportCsv = useCallback(async () => {
    setIsExporting(true);
    try {
      const res = await exportMembers();
      const { body } = validateApiResponse(res, t('members.actions.exportErrorMessage'));
      downloadTextFile(body.file_name, body.csv);
      toast.success({
        title: t('members.actions.exportSuccessTitle'),
        message: t('members.actions.exportSuccessMessage', { file: body.file_name }),
        canClose: true,
      });
    } catch (err) {
      toast.error({
        title: t('members.actions.exportErrorTitle'),
        message: err?.message || t('members.actions.exportErrorMessage'),
        canClose: true,
      });
    } finally {
      setIsExporting(false);
    }
  }, [t, toast]);

  return useMemo(() => ({ exportCsv, isExporting }), [exportCsv, isExporting]);
};
